<template>
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <router-link :to="{path: '/'}">
            <WLogo v-if="isMobile" class="block mx-auto"/>
            <WLogoDesktop v-else class="block mx-auto"/>
        </router-link>
    </div>
</template>

<script setup>
import WLogo from "../icons/w-logo.vue";
import WLogoDesktop from "../icons/w-logo-desktop.vue";
import {useIsMobile} from "../composables/isMobile";
const { isMobile } = useIsMobile()

</script>

<style>
</style>
